(function ($) {
    $(document).ready(function () {
        var checkExist = setInterval(function () {
            if ($('.filter-option').length) {

                $('.filter-block h3').each(function (index, item) {
                    if (item.innerHTML === 'Category') {
                        $(item).parents('.filter-block').addClass('category');
                        var nextList = $(item).next();
                        nextList.find('.filter-option__sub-filter:not(.sub-filter)').parents('.filter-option').addClass('parent');
                        nextList.find('.filter-option__sub-filter.sub-filter').parents('.filter-option').addClass('child');

                        $(document).on('click', '.filter-block.category .topCat', function (e) {
                            var $this = $(this);
                            $this.toggleClass('showTop');

                            $this.nextUntil('.topCat').each(function () {
                                var topCat = $(this);
                                if (topCat.is('.parent')) {
                                    topCat.toggleClass('show');
                                    if (topCat.next().hasClass('parent')) {
                                        topCat.addClass('no-child');
                                    }
                                    if (topCat.hasClass('showChild')) {
                                        topCat.removeClass('showChild');
                                    }
                                }
                            });

                            $this.nextUntil('.topCat').each(function () {
                                var topCat = $(this);

                                if (topCat.is('.child')) {
                                    if (topCat.hasClass('show')) {
                                        topCat.removeClass('show');
                                    }
                                }
                            });
                        });
                        $(document).on('click', '.filter-block.category .parent', function (e) {
                            $(this).toggleClass('showChild');
                            $(this).nextUntil('.parent').each(function () {
                                if ($(this).is('.child')) {
                                    $(this).toggleClass('show');
                                }
                            });
                        });
                    }
                });

                clearInterval(checkExist);
            }
        }, 100); // check every 100ms
    });
}(jQuery));

window.addEventListener('load', () => {
    setInterval(myTimer, 100);
    function myTimer() {
        const filterParent = document.querySelectorAll('.filter-block.category ul li:not(.parent, .child)');

        filterParent.forEach((item, index) => {
            item.classList.add('topCat');
        });
        clearInterval(myTimer);
    }

});